<template>
  <vs-table hover-flat v-if="cdrDatas && cdrDatas.length" :data="cdrDatas">
    <template slot="thead">
      <vs-th v-text="$t('no')"></vs-th>
      <vs-th v-text="$t('number')" v-if="activeColumns.includes('number')"></vs-th>
      <vs-th v-text="$t('company_name')" v-if="activeColumns.includes('company_name')"></vs-th>
      <vs-th v-text="$t('member_name')" v-if="activeColumns.includes('member_name')"></vs-th>
      <vs-th v-text="$t('did')" v-if="activeColumns.includes('did')"></vs-th>
      <vs-th v-text="$t('date')" v-if="activeColumns.includes('date')"></vs-th>
      <vs-th v-text="$t('time')" v-if="activeColumns.includes('time')"></vs-th>
      <vs-th v-text="$t('call_time')" v-if="activeColumns.includes('call_time')"></vs-th>
      <vs-th v-text="$t('treatment_result')" v-if="activeColumns.includes('treatment_result')"></vs-th>
      <vs-th v-text="$t('disposition')" v-if="activeColumns.includes('disposition')"></vs-th>
      <vs-th v-text="$t('ivr_staff')" v-if="activeColumns.includes('ivr_staff')"></vs-th>
      <vs-th v-text="$t('member_groups')" v-if="activeColumns.includes('member_groups')"></vs-th>
      <vs-th v-text="$t('inquiry')" v-if="activeColumns.includes('inquiry')"></vs-th>
      <vs-th v-text="$t('big')" v-if="activeColumns.includes('big')"></vs-th>
      <vs-th v-text="$t('small')" v-if="activeColumns.includes('small')"></vs-th>
      <vs-th class="text-center" v-text="$t('one_touch_record')" v-if="activeColumns.includes('one_touch_record')"></vs-th>
      <vs-th class="text-center" v-text="$t('record_file')" v-if="activeColumns.includes('record_file')"></vs-th>
      <vs-th v-text="customField.name" v-for="(customField, key) in customFields" v-bind:key="'consultationCustomFieldHeader_' + key" v-if="activeColumns.includes(`custom_field_${customField.id}`)"></vs-th>
    </template>

    <template slot-scope="{data}">
      <vs-tr :key="key" v-for="(tr, key) in data">
        <vs-td v-text="tr.count" :data-tr-title="$t('no')"></vs-td>
        <vs-td v-if="activeColumns.includes('number')" v-text="tr.src" :data-tr-title="$t('number')"></vs-td>
        <vs-td v-if="activeColumns.includes('company_name')" :data-tr-title="$t('company_name')">
          <span
            v-text="(tr.company && tr.company.name) ? tr.company.name : ((tr.member && tr.member.company_name) ? tr.member.company_name : '--')"
          ></span>
        </vs-td>
        <vs-td v-if="activeColumns.includes('member_name')" :data-tr-title="$t('member_name')">
          <div class="d-inline-block" v-if="tr.member">
            <span v-if="tr.member.name !== null && tr.member.name.length > 0" v-text="tr.member.name"></span>
            <span v-else>--</span>
          </div>
          <div class="d-inline-block" v-else>
            <span>--</span>
          </div>
        </vs-td>
        <vs-td v-if="activeColumns.includes('did')" v-text="tr.didText" :data-tr-title="$t('did')"></vs-td>
        <vs-td v-if="activeColumns.includes('date')" v-text="tr.date" :data-tr-title="$t('date')"></vs-td>
        <vs-td v-if="activeColumns.includes('time')" v-text="tr.time" :data-tr-title="$t('time')"></vs-td>
        <vs-td v-if="activeColumns.includes('call_time')" v-text="tr.duration" :data-tr-title="$t('call_time')"></vs-td>
        <vs-td v-if="activeColumns.includes('treatment_result')" v-text="tr.treatmentResultText" :data-tr-title="$t('treatment_result')"></vs-td>
        <vs-td v-if="activeColumns.includes('disposition')" v-text="$t(tr.disposition)" :data-tr-title="$t('disposition')"></vs-td>
        <vs-td v-if="activeColumns.includes('ivr_staff')" v-text="tr.ivrText" :data-tr-title="$t('ivr_staff')"></vs-td>
        <vs-td v-if="activeColumns.includes('member_groups')" v-text="tr.member_group_name" :data-tr-title="$t('member_groups')"></vs-td>
        <vs-td v-if="activeColumns.includes('inquiry')" v-text="tr.inquiry_name" :data-tr-title="$t('inquiry')"></vs-td>
        <vs-td v-if="activeColumns.includes('big')" v-text="tr.big_name" :data-tr-title="$t('big')"></vs-td>
        <vs-td v-if="activeColumns.includes('small')" v-text="tr.small_name" :data-tr-title="$t('small')"></vs-td>
        <vs-td v-if="activeColumns.includes('one_touch_record')" :data-tr-title="$t('one_touch_record')">
          <div class="flex justify-center" v-if="tr.disposition === 'NO ANSWER'" />
          <div class="flex justify-center gap-2" v-else>
            <vx-tooltip :text="$t('play')" position="bottom">
              <vs-button color="primary" type="border" icon-pack="feather" icon="icon-play" size="small" @click.prevent="playOneTouchRecording(tr.src, tr.uniqueid)"></vs-button>
            </vx-tooltip>
            <vx-tooltip :text="$t('download')" position="bottom">
              <vs-button color="primary" type="border" icon-pack="feather" icon="icon-download" size="small" @click.prevent="downloadOneTouchRecording(tr.src, tr.uniqueid)"></vs-button>
            </vx-tooltip>
          </div>
        </vs-td>
        <vs-td v-if="activeColumns.includes('record_file')" :data-tr-title="$t('record_file')">
          <div class="flex justify-center" v-text="$t('no_transcript_file')" v-if="tr.disposition === 'NO ANSWER'" />
          <div class="flex justify-center gap-2" v-else>
            <vx-tooltip :text="$t('play')" position="bottom">
              <vs-button color="primary" type="border" icon-pack="feather" icon="icon-play" size="small" @click.prevent="playRecording(tr.src, tr.uniqueid)"></vs-button>
            </vx-tooltip>

            <vx-tooltip :text="$t('download')" position="bottom">
              <vs-button color="primary" type="border" icon-pack="feather" icon="icon-download" size="small" @click.prevent="downloadRecording(tr.src, tr.uniqueid)"></vs-button>
            </vx-tooltip>

            <vx-tooltip :text="$t('call_note')" position="bottom" v-if="$store.getters.hasCompanyPermission('company_can_use_callnote') && parseInt(tr.duration) >= 60">
              <vs-button color="primary" type="border" icon-pack="feather" icon="icon-clipboard" size="small" @click.prevent="callNoteConvert({ src: tr.src, uniqueId: tr.uniqueid })"></vs-button>
            </vx-tooltip>
          </div>
        </vs-td>
        <vs-td v-for="(customField, key) in customFields" v-bind:key="'consultationCustomField_' + key" v-if="activeColumns.includes(`custom_field_${customField.id}`)" :data-tr-title="customField.name">
            <span v-for="(customFieldData, key) in tr.custom_fields" v-bind:key="'consultationCustomFieldData_' + key">
              <span v-if="customFieldData.custom_field_id == customField.id">{{ customFieldData.value }}</span>
            </span>
        </vs-td>
      </vs-tr>
    </template>
  </vs-table>
  <vs-alert v-else class="flex justify-center p-0 h-auto" color="danger" active="true">
    <div v-text="$t('no_record')"></div>
  </vs-alert>
</template>

<script>
import ctiWindow from '@/helpers/ctiWindow'
import Consultation from '@/models/Consultation'
import Cti from '@/models/Cti'

export default {
  name: 'Shared.InboundDetails.List',
  props: {
    cdrDatas: {
      type: [Object, Array],
      required: true
    },
    customFields: {
      type: [Object, Array],
      required: true
    },
    activeColumns: {
      type: [Object, Array],
      required: true
    }
  },
  methods: {
    playRecording (src, uniqueId) {
      ctiWindow.consultationRecordingFile(src, uniqueId)
    },
    async downloadRecording (src, uniqueId) {
      try {
        await Consultation.downloadRecording({src, uniqueId, companyId: this.$store.getters.userInfo.company.id, type: 'inbound'})
      } catch (e) {
        this.$alertHelper.error()
      }
    },
    playOneTouchRecording (src, uniqueId) {
      ctiWindow.consultationOneTouchRecordingFile(src, uniqueId)
    },
    async downloadOneTouchRecording (src, uniqueId) {
      try {
        await Consultation.downloadOneTouchRecording({src, uniqueId, companyId: this.$store.getters.userInfo.company.id, type: 'inbound'})
      } catch (e) {
        this.$alertHelper.error()
      }
    },
    async callNoteConvert ({ src, uniqueId }) {
      const response = await Cti.showRecordingFile({
        unique_id: uniqueId,
        src
      })

      ctiWindow.openCallNoteWindow(response.data.path)
    }
  }
}
</script>

<style scoped>

</style>
